import { FramerPage } from 'Pages/FramerPage';

const Premium = () => <FramerPage path="premium" />;

export default Premium;
